import { render, staticRenderFns } from "./WatchlistHome.vue?vue&type=template&id=f7063544&"
import script from "./WatchlistHome.vue?vue&type=script&lang=js&"
export * from "./WatchlistHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports